<template>
  <div class="user-modern">
    <NavBar />
    <AuthBySessionExpired />
    <NewGroup @created="getUserGroups" />
    <NewProfile @created="getUserProfiles" />
    <ChangePassword :user_id="id" :email="original_email" />

    <div class="user-container">
      <!-- Header Section -->
      <div class="user-header">
        <div class="header-content">
          <div class="back-button-section">
            <v-btn class="btn-return" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2"></i>
              VOLTAR
            </v-btn>
          </div>
          <div class="title-section">
            <h1 class="page-title">
              <i class="fas fa-user-edit title-icon"></i>
              {{ name || "Novo Usuário" }}
            </h1>
            <p class="page-subtitle">
              Gerencie informações do usuário e configurações de acesso
            </p>
          </div>
        </div>
      </div>

      <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
        <!-- Warning Messages -->
        <div
          v-if="!permission('edit', 'user') || by_transfer == 1"
          class="warning-section"
        >
          <WarningMessage
            v-if="!permission('edit', 'user')"
            message="Você não tem permissão para modificar usuários"
          />
          <WarningMessage
            v-if="by_transfer == 1"
            message="Usuário cadastrado por transferência de residente. Não é possível editar!"
          />
        </div>

        <form @submit.prevent="update" class="user-form">
          <!-- Modern Navigation Tabs -->
          <div class="tabs-container">
            <nav class="modern-tabs">
              <button
                type="button"
                @click="
                  step = 'INFORMATION';
                  errors = [];
                "
                :class="['tab-btn', step == 'INFORMATION' && 'active']"
              >
                <i class="fas fa-user"></i>
                <span>Informações</span>
              </button>

              <button
                v-if="
                  (id == loggedin_user_id &&
                    use_certificate == 1 &&
                    dashboard_monitoring == 0) ||
                  (permission('read', 'user_certificate') &&
                    dashboard_monitoring == 0)
                "
                type="button"
                @click="
                  step = 'CERTIFICATE';
                  errors = [];
                "
                :class="['tab-btn', step == 'CERTIFICATE' && 'active']"
              >
                <i class="fas fa-certificate"></i>
                <span>Certificado</span>
              </button>

              <button
                v-if="dashboard_monitoring == 0"
                type="button"
                @click="
                  step = 'PROFESSION';
                  errors = [];
                "
                :class="['tab-btn', step == 'PROFESSION' && 'active']"
              >
                <i class="fas fa-briefcase"></i>
                <span>Profissão</span>
              </button>

              <button
                v-if="
                  permission('read', 'digital_recipe') &&
                  dashboard_monitoring == 0
                "
                type="button"
                @click="
                  step = 'MEMED';
                  errors = [];
                "
                :class="['tab-btn', step == 'MEMED' && 'active']"
              >
                <i class="fas fa-user"></i>
                <span>MEMED</span>
              </button>

              <button
                v-if="dashboard_monitoring == 0"
                type="button"
                @click="
                  step = 'DOCUMENTS';
                  errors = [];
                "
                :class="['tab-btn', step == 'DOCUMENTS' && 'active']"
              >
                <i class="fas fa-id-card"></i>
                <span>Documentos</span>
              </button>

              <button
                v-if="dashboard_monitoring == 0"
                type="button"
                @click="
                  step = 'ADDRESS';
                  errors = [];
                "
                :class="['tab-btn', step == 'ADDRESS' && 'active']"
              >
                <i class="fas fa-map-marker-alt"></i>
                <span>Endereço</span>
              </button>

              <button
                type="button"
                @click="
                  step = 'ACCESS';
                  errors = [];
                "
                :class="['tab-btn', step == 'ACCESS' && 'active']"
              >
                <i class="fas fa-key"></i>
                <span>Acesso</span>
              </button>

              <button
                v-if="dashboard_monitoring == 0"
                type="button"
                @click="
                  step = 'FOREIGN';
                  errors = [];
                "
                :class="['tab-btn', step == 'FOREIGN' && 'active']"
              >
                <i class="fas fa-globe"></i>
                <span>Estrangeiro</span>
              </button>

              <button
                v-if="by_transfer == 0 && dashboard_monitoring == 0"
                type="button"
                @click="
                  step = 'PHOTO';
                  errors = [];
                "
                :class="['tab-btn', step == 'PHOTO' && 'active']"
              >
                <i class="fas fa-camera"></i>
                <span>Foto</span>
              </button>

              <button
                v-if="
                  permission('read', 'config_home_care') &&
                  by_transfer == 0 &&
                  dashboard_monitoring == 0
                "
                type="button"
                @click="
                  step = 'HOME_CARE';
                  errors = [];
                "
                :class="['tab-btn', step == 'HOME_CARE' && 'active']"
              >
                <i class="fas fa-home"></i>
                <span>Home Care</span>
              </button>

              <button
                v-if="
                  permission('read', 'geolocation') && dashboard_monitoring == 0
                "
                type="button"
                @click="
                  step = 'GEOLOCATION';
                  errors = [];
                "
                :class="['tab-btn', step == 'GEOLOCATION' && 'active']"
              >
                <i class="fas fa-map-pin"></i>
                <span>Localização</span>
              </button>

              <button
                v-if="dashboard_monitoring == 0"
                type="button"
                @click="
                  step = 'FOLDER';
                  errors = [];
                "
                :class="['tab-btn', step == 'FOLDER' && 'active']"
              >
                <i class="fas fa-folder"></i>
                <span>Pastas</span>
              </button>

              <button
                v-if="
                  user_technical_responsible == 1 && dashboard_monitoring == 0
                "
                type="button"
                @click="
                  step = 'TECHNICAL_MANAGER';
                  errors = [];
                "
                :class="['tab-btn', step == 'TECHNICAL_MANAGER' && 'active']"
              >
                <i class="fas fa-user-cog"></i>

                <span>Res. Técnico</span>
              </button>
            </nav>
          </div>

          <!-- Tab Content -->
          <div class="tab-content-modern">
            <!-- INFORMAÇÕES -->
            <div v-show="step == 'INFORMATION'" class="tab-panel">
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="fas fa-user mr-2"></i>
                    Informações Pessoais
                  </h3>
                </div>
                <div class="card-content">
                  <div class="form-grid">
                    <div class="form-group span-2">
                      <LabelRequiredField label="Nome" />
                      <input
                        type="text"
                        ref="autofocus"
                        v-model="name"
                        class="form-control-modern"
                        placeholder="Nome completo do usuário"
                      />
                    </div>

                    <div class="form-group" v-if="dashboard_monitoring == 0">
                      <label class="form-label">Nome social/Apelido</label>
                      <input
                        type="text"
                        v-model="nickname"
                        class="form-control-modern"
                        placeholder="Nome social ou apelido"
                      />
                    </div>

                    <div class="form-group" v-if="dashboard_monitoring == 0">
                      <label class="form-label">Data de nascimento</label>
                      <input
                        type="date"
                        v-model="date_of_birth"
                        class="form-control-modern"
                      />
                      <small
                        v-if="date_of_birth && date_of_birth.length == 10"
                        class="form-help"
                      >
                        Idade: {{ getAge(date_of_birth) }} anos
                      </small>
                    </div>

                    <div class="form-group" v-if="dashboard_monitoring == 0">
                      <label class="form-label">Gênero</label>
                      <select v-model="gender_id" class="form-control-modern">
                        <option :value="null">Selecione...</option>
                        <option
                          v-for="value in genders"
                          :key="value.id"
                          :value="value.id"
                        >
                          {{ String(value.name).toUpperCase() }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group" v-if="dashboard_monitoring == 0">
                      <label class="form-label">Nacionalidade</label>
                      <input
                        type="text"
                        v-model="nationality"
                        class="form-control-modern"
                        placeholder="Ex: Brasileira"
                      />
                    </div>

                    <div class="form-group" v-if="dashboard_monitoring == 0">
                      <label class="form-label">Município de nascimento</label>
                      <input
                        type="text"
                        v-model="city_of_birth"
                        class="form-control-modern"
                        placeholder="Cidade onde nasceu"
                      />
                    </div>

                    <div class="form-group" v-if="dashboard_monitoring == 0">
                      <label class="form-label">UF</label>
                      <select
                        v-model="city_of_birth_uf_id"
                        class="form-control-modern"
                      >
                        <option :value="null">Selecione...</option>
                        <option
                          v-for="value in ufs"
                          :key="value.id"
                          :value="value.id"
                        >
                          {{ value.name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group">
                      <LabelRequiredField label="Grupo" />
                      <div class="input-group-modern">
                        <select
                          v-model="user_group_id"
                          class="form-control-modern"
                        >
                          <option
                            v-for="value in userGroups"
                            :key="value.id"
                            :value="value.id"
                          >
                            {{ String(value.name).toUpperCase() }}
                          </option>
                        </select>
                        <v-btn
                          v-if="by_transfer == 0"
                          type="button"
                          class="btn-add-modern"
                          @click="$bvModal.show('new_group')"
                        >
                          <i class="fas fa-plus"></i>
                        </v-btn>
                      </div>
                    </div>

                    <div class="form-group">
                      <LabelRequiredField label="Perfil" />
                      <div class="input-group-modern">
                        <select
                          v-model="user_profile_id"
                          class="form-control-modern"
                        >
                          <option
                            v-for="value in userProfiles"
                            :key="value.id"
                            :value="value.id"
                          >
                            {{ String(value.name).toUpperCase() }}
                          </option>
                        </select>
                        <v-btn
                          v-if="by_transfer == 0"
                          type="button"
                          class="btn-add-modern"
                          @click="$bvModal.show('new_profile')"
                        >
                          <i class="fas fa-plus"></i>
                        </v-btn>
                      </div>
                    </div>

                    <div class="form-group">
                      <LabelRequiredField label="Status" />
                      <select
                        v-model="status_type_id"
                        class="form-control-modern"
                      >
                        <option
                          v-for="value in statusTypes"
                          :key="value.id"
                          :value="value.id"
                        >
                          {{ String(value.name).toUpperCase() }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group" v-if="dashboard_monitoring == 0">
                      <label class="form-label">Telefone</label>
                      <input
                        type="text"
                        v-model="phone"
                        class="form-control-modern"
                        @input="formatPhone"
                        placeholder="(00) 0.0000-0000"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- CERTIFICADO -->
            <div v-show="step == 'CERTIFICATE'" class="tab-panel">
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="fas fa-certificate mr-2"></i>
                    Certificado Digital
                  </h3>
                </div>
                <div class="card-content">
                  <Certificate
                    :user_id="id"
                    :use_certificate="use_certificate"
                    :protocol="protocol"
                    :cpf="cpf"
                    :user_bry_certificate="user_bry_certificate"
                    @save="retrieve()"
                  />
                </div>
              </div>
            </div>

            <!-- PROFISSÃO -->
            <div v-show="step == 'PROFESSION'" class="tab-panel">
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="fas fa-briefcase mr-2"></i>
                    Informações Profissionais
                  </h3>
                </div>
                <div class="card-content">
                  <div>
                    <div class="form-group">
                      <div class="checkbox-modern">
                        <input
                          class="checkbox-input"
                          type="checkbox"
                          v-model="doctor"
                          id="doctor"
                        />
                        <label class="checkbox-label" for="doctor">
                          <i class="fas fa-user-md mr-2"></i>
                          MÉDICO
                        </label>
                      </div>
                      <small class="form-help">
                        Marque esta opção para aparecer nas receitas!
                      </small>
                    </div>

                    <div
                      class="form-group"
                      v-if="permission('read', 'technical_responsible')"
                    >
                      <div class="checkbox-modern">
                        <input
                          class="checkbox-input"
                          type="checkbox"
                          v-model="technical_responsible"
                          id="technical_responsible"
                        />
                        <label
                          class="checkbox-label"
                          for="technical_responsible"
                        >
                          <i class="fas fa-user-md mr-2"></i>
                          RESPONSÁVEL TÉCNICO
                        </label>
                      </div>
                      <small class="form-help">
                        Marque esta opção para aparecer RT nas assinaturas do
                        usuário!
                      </small>
                    </div>

                    <div class="form-group">
                      <div class="text-end">
                        <v-btn
                          :disabled="!action_update"
                          v-if="permission('edit', 'user') && by_transfer == 0"
                          class="btn-save-modern"
                          @click="updateProfessionCheckbox"
                        >
                          <i
                            :class="[
                              'fas mr-2',
                              !action_update && 'fa-spinner fa-spin',
                              action_update && 'fa-save',
                            ]"
                          ></i>
                          {{
                            !action_update
                              ? `AGUARDE ${time_action_update}(s)`
                              : "SALVAR"
                          }}
                        </v-btn>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div class="form-grid">
                    <div class="form-group">
                      <label class="form-label">Cargo</label>
                      <input
                        type="text"
                        v-model="office"
                        class="form-control-modern"
                        placeholder="Cargo ou função"
                      />
                    </div>

                    <div class="form-group span-2">
                      <label class="form-label"
                        >Conselho de classe profissional</label
                      >
                      <select
                        class="form-control-modern"
                        v-model="professional_class_council"
                      >
                        <option :value="{ id: null, name: null }">
                          NENHUM
                        </option>
                        <option
                          v-for="value in professional_class_councils"
                          :key="value.id"
                          :value="value"
                        >
                          {{ value.name }}
                        </option>
                      </select>
                    </div>

                    <!-- COREN Fields -->
                    <div
                      v-if="professional_class_council.name == 'COREN'"
                      class="form-group span-full"
                    >
                      <div class="coren-section">
                        <h4 class="section-title">
                          <i class="fas fa-id-badge mr-2"></i>
                          Informações COREN
                        </h4>
                        <div class="form-grid">
                          <div class="form-group">
                            <label class="form-label">UF</label>
                            <select
                              v-model="coren_uf"
                              class="form-control-modern"
                            >
                              <option :value="null">Selecione...</option>
                              <option
                                v-for="value in ufs"
                                :key="value.id"
                                :value="value.initials"
                              >
                                {{ value.name }}
                              </option>
                            </select>
                          </div>

                          <div class="form-group">
                            <label class="form-label">Código</label>
                            <input
                              type="text"
                              v-model="coren_code"
                              @input="formatCoren"
                              class="form-control-modern"
                              placeholder="000000"
                            />
                          </div>

                          <div class="form-group">
                            <label class="form-label">Categoria</label>
                            <select
                              v-model="coren_category"
                              class="form-control-modern"
                            >
                              <option :value="null">Selecione...</option>
                              <option value="ENF">Enfermeiro(a)</option>
                              <option value="OBST">Obstetriz</option>
                              <option value="TE">Técnico de Enfermagem</option>
                              <option value="AE">Auxiliar de Enfermagem</option>
                              <option value="PAR">Parteira</option>
                              <option value="AUT">
                                Anotação do número de autorização
                              </option>
                              <option value="AT">
                                Atendente de Enfermagem
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Other Professional Council Fields -->
                    <div
                      v-if="
                        professional_class_council &&
                        professional_class_council.name != 'COREN' &&
                        professional_class_council.id
                      "
                      class="form-group span-full"
                    >
                      <div class="council-section">
                        <h4 class="section-title">
                          <i class="fas fa-id-badge mr-2"></i>
                          {{ professional_class_council.name }}
                        </h4>
                        <div class="form-grid">
                          <div class="form-group">
                            <label class="form-label">{{
                              professional_class_council.name
                            }}</label>
                            <input
                              type="text"
                              placeholder="Somente números"
                              v-model="crm_value"
                              v-mask="'##########'"
                              class="form-control-modern"
                            />
                          </div>

                          <div class="form-group">
                            <label class="form-label">UF</label>
                            <select
                              v-model="crm_uf"
                              class="form-control-modern"
                            >
                              <option :value="null">Selecione...</option>
                              <option
                                v-for="value in ufs"
                                :key="value.id"
                                :value="value.initials"
                              >
                                {{ value.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card-actions">
                    <v-btn
                      :disabled="!action_update"
                      v-if="permission('edit', 'user') && by_transfer == 0"
                      class="btn-save-modern"
                      @click="updateProfession"
                    >
                      <i
                        :class="[
                          'fas mr-2',
                          !action_update && 'fa-spinner fa-spin',
                          action_update && 'fa-save',
                        ]"
                      ></i>
                      {{
                        !action_update
                          ? `AGUARDE ${time_action_update}(s)`
                          : "SALVAR"
                      }}
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>

            <!-- MEMED -->
            <div v-show="step == 'MEMED'" class="tab-panel">
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="fas fa-briefcase mr-2"></i>
                    Informações MEMED
                  </h3>
                </div>
                <div class="card-content">
                  <UserMemed v-if="user" :user="user" />
                </div>
              </div>
            </div>

            <!-- DOCUMENTOS -->
            <div v-show="step == 'DOCUMENTS'" class="tab-panel">
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="fas fa-id-card mr-2"></i>
                    Documentos
                  </h3>
                </div>
                <div class="card-content">
                  <div class="form-grid">
                    <div class="form-group">
                      <LabelRequiredField label="CPF" />
                      <BInputCPF v-model="cpf" />
                    </div>

                    <div class="form-group">
                      <label class="form-label">Número de identidade</label>
                      <input
                        type="text"
                        v-model="identity_number"
                        class="form-control-modern"
                        placeholder="00.000.000-0"
                      />
                    </div>

                    <div class="form-group">
                      <label class="form-label">Complemento</label>
                      <input
                        type="text"
                        v-model="complement"
                        class="form-control-modern"
                        placeholder="Complemento do documento"
                      />
                    </div>

                    <div class="form-group">
                      <label class="form-label">UF</label>
                      <select
                        v-model="complement_uf_id"
                        class="form-control-modern"
                      >
                        <option :value="null">Selecione...</option>
                        <option
                          v-for="value in ufs"
                          :key="value.id"
                          :value="value.id"
                        >
                          {{ value.name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label class="form-label">Órgão</label>
                      <input
                        type="text"
                        v-model="complement_agency"
                        class="form-control-modern"
                        placeholder="Ex: SSP"
                      />
                    </div>

                    <div class="form-group">
                      <label class="form-label">Data de emissão</label>
                      <input
                        type="date"
                        v-model="complement_issue_date"
                        class="form-control-modern"
                      />
                    </div>

                    <div class="form-group span-2">
                      <label class="form-label"
                        >Número do cartão nacional de saúde (CNS)</label
                      >
                      <input
                        type="text"
                        v-model="national_health_card_number"
                        class="form-control-modern"
                        placeholder="000 0000 0000 0000"
                      />
                    </div>

                    <div class="form-group">
                      <label class="form-label">Código e descrição CBO</label>
                      <input
                        type="text"
                        v-model="code_and_description"
                        class="form-control-modern"
                        placeholder="Ex: 2231-77"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- ENDEREÇO -->
            <div v-show="step == 'ADDRESS'" class="tab-panel">
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="fas fa-map-marker-alt mr-2"></i>
                    Endereço
                  </h3>
                </div>
                <div class="card-content">
                  <div class="form-grid">
                    <div class="form-group">
                      <label class="form-label">CEP</label>
                      <BInputCEP v-model="cep" @retrieved="evOnCEPRetrieved" />
                    </div>

                    <div class="form-group span-2">
                      <label class="form-label">Cidade</label>
                      <input
                        type="text"
                        v-model="city"
                        class="form-control-modern"
                        placeholder="Nome da cidade"
                      />
                    </div>

                    <div class="form-group">
                      <label class="form-label">UF</label>
                      <select v-model="uf_id" class="form-control-modern">
                        <option :value="null">Selecione...</option>
                        <option
                          v-for="value in ufs"
                          :key="value.id"
                          :value="value.id"
                        >
                          {{ value.name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group span-2">
                      <label class="form-label">Endereço</label>
                      <input
                        type="text"
                        v-model="address"
                        class="form-control-modern"
                        placeholder="Rua, avenida, etc."
                      />
                    </div>

                    <div class="form-group">
                      <label class="form-label">Número</label>
                      <input
                        type="text"
                        v-model="number_address"
                        class="form-control-modern"
                        placeholder="123"
                      />
                    </div>

                    <div class="form-group">
                      <label class="form-label">Bairro</label>
                      <input
                        type="text"
                        v-model="district"
                        class="form-control-modern"
                        placeholder="Nome do bairro"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- ACESSO -->
            <div v-show="step == 'ACCESS'" class="tab-panel">
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="fas fa-key mr-2"></i>
                    Acesso ao Sistema
                  </h3>
                </div>
                <div class="card-content">
                  <div class="form-grid">
                    <div class="form-group span-full">
                      <LabelRequiredField label="E-mail" />
                      <input
                        type="email"
                        v-model="email"
                        class="form-control-modern"
                        placeholder="usuario@email.com"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- ESTRANGEIRO -->
            <div v-show="step == 'FOREIGN'" class="tab-panel">
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="fas fa-globe mr-2"></i>
                    Informações de Estrangeiro
                  </h3>
                </div>
                <div class="card-content">
                  <div class="form-grid">
                    <div class="form-group">
                      <label class="form-label">Data de naturalização</label>
                      <input
                        type="date"
                        v-model="naturalization_date"
                        class="form-control-modern"
                      />
                    </div>

                    <div class="form-group">
                      <label class="form-label">País de nascimento</label>
                      <input
                        type="text"
                        v-model="country_of_birth"
                        class="form-control-modern"
                        placeholder="Ex: Argentina"
                      />
                    </div>

                    <div class="form-group">
                      <label class="form-label">Número do passaporte</label>
                      <input
                        type="text"
                        v-model="passport_number"
                        class="form-control-modern"
                        placeholder="000000000"
                      />
                    </div>

                    <div class="form-group">
                      <label class="form-label">País emissor</label>
                      <input
                        type="text"
                        v-model="issuing_country"
                        class="form-control-modern"
                        placeholder="País que emitiu o passaporte"
                      />
                    </div>

                    <div class="form-group">
                      <label class="form-label">Data de emissão</label>
                      <input
                        type="date"
                        v-model="date_of_issue"
                        class="form-control-modern"
                      />
                    </div>

                    <div class="form-group">
                      <label class="form-label">Data de validade</label>
                      <input
                        type="date"
                        v-model="expiry_date"
                        class="form-control-modern"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- FOTO -->
            <div v-show="step == 'PHOTO'" class="tab-panel">
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="fas fa-camera mr-2"></i>
                    Foto do Usuário
                  </h3>
                </div>
                <div class="card-content">
                  <b-overlay
                    :show="loadingImage"
                    opacity="0.99"
                    class="photo-overlay"
                  >
                    <div class="photo-section">
                      <div class="photo-preview">
                        <img
                          :src="
                            photo_url
                              ? photo_url
                              : require('../assets/user.png')
                          "
                          class="profile-image-large"
                          alt="Foto do usuário"
                        />
                      </div>

                      <div class="photo-actions">
                        <label class="btn-upload-photo">
                          <i
                            :class="[
                              photo_url ? 'fas fa-sync-alt' : 'fas fa-camera',
                              'mr-2',
                            ]"
                          ></i>
                          {{ photo_url ? "SUBSTITUIR" : "ADICIONAR" }}
                          <input
                            type="file"
                            @change="updateProfilePic($event.target.files[0])"
                            class="file-input-hidden"
                            ref="button_img"
                            accept="image/*"
                          />
                        </label>

                        <v-btn
                          v-if="photo_url"
                          class="btn-remove-photo"
                          @click="deleteProfilePic"
                        >
                          <i class="fas fa-trash mr-2"></i>
                          REMOVER
                        </v-btn>
                      </div>

                      <div class="photo-info">
                        <p class="info-text">
                          <i class="fas fa-info-circle mr-1"></i>
                          Tamanho máximo <strong>10MB</strong>
                        </p>
                        <p class="info-text">
                          Formatos: <strong>JPG, JPEG, PJPEG</strong> e
                          <strong>PNG</strong>
                        </p>
                      </div>

                      <ErrorsMessages :errors="new_profile_pic_errors" />
                    </div>
                  </b-overlay>
                </div>
              </div>
            </div>

            <!-- HOME CARE -->
            <div
              v-show="
                step == 'HOME_CARE' && permission('read', 'config_home_care')
              "
              class="tab-panel"
            >
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="fas fa-home mr-2"></i>
                    Home Care / Família
                  </h3>
                </div>
                <div class="card-content">
                  <HomeCare
                    :user_id="id"
                    :allow_home_care="allow_home_care"
                    @save="get()"
                  />
                </div>
              </div>
            </div>

            <!-- GEOLOCALIZAÇÃO -->
            <div v-show="step == 'GEOLOCATION'" class="tab-panel">
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="fas fa-map-pin mr-2"></i>
                    Geolocalização
                  </h3>
                </div>
                <div class="card-content">
                  <Geolocation
                    :user_id="id"
                    :geolocation="geolocation"
                    @save="get()"
                  />
                </div>
              </div>
            </div>

            <!-- PASTAS -->
            <div v-show="step == 'FOLDER'" class="tab-panel">
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="fas fa-folder mr-2"></i>
                    Documentos Visualizados
                  </h3>
                </div>
                <div class="card-content">
                  <Folder :user_id="Number(id)" />
                </div>
              </div>
            </div>

            <!-- RESPONSAVEL TECNICO -->
            <div v-show="step == 'TECHNICAL_MANAGER'" class="tab-panel">
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="fas fa-user-cog mr-2"></i>

                    Informações Responsável Técnico
                  </h3>
                </div>
                <div class="card-content">
                  <TechnicalManager :user_id="Number(id)" />
                </div>
              </div>
            </div>
          </div>

          <!-- Footer Actions -->
          <div v-if="step != 'GEOLOCATION'" class="form-footer">
            <div class="footer-info">
              <WarningRequiredFields v-if="permission('edit', 'user')" />
              <ErrorsMessages :errors="errors" />

              <div v-if="step != 'CERTIFICATE'" class="creation-info">
                <p class="info-item">
                  <i class="fas fa-calendar-plus mr-2"></i>
                  Criação: {{ formatDate(created_at) }}
                </p>
                <p class="info-item">
                  <i class="fas fa-edit mr-2"></i>
                  Última alteração: {{ formatDate(updated_at) }}
                </p>
              </div>
            </div>

            <div v-if="step != 'CERTIFICATE'" class="footer-actions">
              <div class="left-actions">
                <v-btn
                  v-if="permission('read', 'permission') && by_transfer == 0"
                  @click="handleToPermissions"
                  class="btn-secondary-modern"
                >
                  <i class="fas fa-shield-alt mr-2"></i>
                  PERMISSÕES
                </v-btn>

                <v-btn
                  v-if="permission('edit', 'user') && by_transfer == 0"
                  class="btn-secondary-modern"
                  @click="$bvModal.show('change_password')"
                >
                  <i class="fas fa-lock mr-2"></i>
                  ALTERAR SENHA
                </v-btn>

                <v-btn class="btn-secondary-modern" @click="print">
                  <i class="fas fa-print mr-2"></i>
                  IMPRIMIR
                </v-btn>
              </div>

              <div class="right-actions">
                <v-btn
                  :disabled="!action_update"
                  v-if="
                    permission('edit', 'user') &&
                    step != 'PHOTO' &&
                    step != 'PROFESSION' &&
                    step != 'FOLDER' &&
                    step != 'HOME_CARE' &&
                    step != 'MEMED' &&
                    by_transfer == 0
                  "
                  type="submit"
                  class="btn-primary-modern"
                >
                  <i
                    :class="[
                      'fas mr-2',
                      !action_update && 'fa-spinner fa-spin',
                      action_update && 'fa-save',
                    ]"
                  ></i>
                  {{
                    !action_update
                      ? `AGUARDE ${time_action_update}(s)`
                      : "SALVAR"
                  }}
                </v-btn>
              </div>
            </div>
          </div>
        </form>

        <Password
          @password="handlePassword"
          :errorsPassword="errorsPassword"
          :loading="loading"
        />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import WarningMessage from "../templates/Components/WarningMessage";
import LabelRequiredField from "../templates/Components/LabelRequiredField";

import WarningRequiredFields from "../templates/Components/WarningRequiredFields";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import Password from "../templates/User/Password";
import HomeCare from "../templates/User/home-care";
import Certificate from "../templates/User/certificate";
import Geolocation from "../templates/User/Geolocation";
import Folder from "../templates/User/Folder";
import UserMemed from "../templates/User/Memed";
import TechnicalManager from "../templates/User/TechnicalManager";

import api from "../services/api";

import toast from "../lib/ToastNotification";
import permission from "../lib/permission";
import { formatDate, onlyCodeCoren } from "../lib/format";
import routes from "../routes";
import NewGroup from "../templates/Groups/NewGroup";
import NewProfile from "../templates/Profiles/NewProfile";
import ChangePassword from "../templates/User/ChangePassword";
import { getStatic, userData } from "../lib/functions";
import { getAge } from "../lib/getAgeByDate";

import BInputCPF from "../templates/Components/BInputCPF.vue";
import BInputCEP from "../templates/Components/BInputCEP.vue";
import moment from "moment";

export default {
  name: "User",
  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    WarningMessage,
    LabelRequiredField,
    WarningRequiredFields,
    NewProfile,
    NewGroup,
    ChangePassword,
    Password,
    BInputCPF,
    BInputCEP,
    HomeCare,
    Certificate,
    Geolocation,
    Folder,
    UserMemed,
    TechnicalManager,
  },

  data() {
    return {
      loggedin_user_id: null,
      user: null,

      step: "INFORMATION",
      typeAction: "UPDATE",

      user_bry_certificate: null,

      use_certificate: 0,
      protocol: null,

      ufs: [],
      statusTypes: [],
      userGroups: [],
      userProfiles: [],
      genders: [],
      id: "",
      dashboard_monitoring: 0,
      status_type_id: "",
      user_group_id: "",
      user_profile_id: "",
      name: "",
      nickname: "",
      date_of_birth: "",
      gender_id: null,
      nationality: "",
      city_of_birth: "",
      identity_number: "",
      complement: "",
      complement_uf_id: null,
      complement_agency: "",
      complement_issue_date: "",
      national_health_card_number: "",
      code_and_description: "",
      city_of_birth_uf_id: null,
      naturalization_date: "",
      country_of_birth: "",
      passport_number: "",
      issuing_country: "",
      date_of_issue: "",
      expiry_date: "",
      cpf: "",
      professional_class_councils: [],
      professional_class_council: { id: null, name: null },
      professional_class_councils_id: "",
      crm_value: "",
      crm_uf: null,
      coren_uf: null,
      coren_code: "",
      coren_category: null,
      email: "",
      original_email: "",
      uf_id: null,
      phone: "",
      cep: "",
      city: "",
      address: "",
      number_address: "",
      district: "",
      doctor: null,
      technical_responsible: null,
      user_technical_responsible: null,
      photo_url: "",
      office: "",
      created_at: "",
      updated_at: "",
      password: "",
      allow_home_care: null,
      loading: true,
      loadingImage: false,
      new_profile_pic: null,
      width: window.screen.width,
      new_profile_pic_errors: [],
      action_update: true,
      time_action_update: 0,
      errors: [],
      errorsPassword: [],
      by_transfer: 0,
      geolocation: null,
    };
  },
  created() {
    this.retrieve();
    window.addEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },
  methods: {
    permission,
    formatDate,
    onlyCodeCoren,
    getAge,
    handlePassword(password) {
      this.password = password;
      if (this.typeAction == "UPDATE") {
        this.update();
      } else if (this.typeAction == "PROFESSION_CHECKBOX") {
        this.updateProfessionCheckbox();
      } else {
        this.updateProfession();
      }
    },
    hanldeIntervalToUpdate() {
      setInterval(() => {
        if (this.time_action_update > 0) {
          this.time_action_update--;
        } else {
          this.action_update = true;
          this.time_action_update = 0;
          return;
        }
      }, 1000);
    },
    handleOnResize() {
      this.width = window.innerWidth;
    },

    async evOnCEPRetrieved(value) {
      this.cep = value.cep;
      this.city = value.localidade || this.city;
      this.neighborhood = value.bairro || this.neighborhood;
      // this.complement = value.complemento || this.complement;
      this.address = value.logradouro || this.address;

      const matched_uf = this.ufs.find(
        (item) => item.initials.toLowerCase() === value.uf.toLowerCase()
      );
      if (matched_uf) this.uf_id = matched_uf.id;
    },

    handleChangeProfessionalClassCouncils(id) {
      let { professional_class_councils } = this;

      for (let item of professional_class_councils) {
        if (item.id == id) {
          this.professional_class_council = item;
        }
      }
    },
    async retrieve() {
      let { id: loggedin_user_id } = userData().user;

      this.loggedin_user_id = loggedin_user_id;

      const { id } = routes.history.current.params;
      this.id = id;

      await this.getStatusUsers();
      if (this.errors.length == 0) await this.getUserGroups();
      if (this.errors.length == 0) await this.getUserProfiles();
      if (this.errors.length == 0) await this.getGenders();
      if (this.errors.length > 0) return;

      try {
        this.ufs = (await getStatic("/ufs", true)).ufs;
        this.professional_class_councils = (
          await getStatic("/professional-class-councils", true)
        ).professional_class_councils;
      } catch (errors) {
        this.errors = errors;
      }

      this.professional_class_councils.push({
        id: "",
        name: "NÃO INFORMAR",
      });

      await this.get();
      await this.getUserBryCertificateByUserId();
    },
    async get() {
      try {
        this.loading = true;

        const { id } = this;

        let params = { id };

        const response = await api.get("/rest-home/user", {
          params,
        });

        const { user, error } = response.data;

        if (error) {
          return routes.push({ name: "users" });
        }

        this.user = user;
        this.dashboard_monitoring = user.dashboard_monitoring;
        this.by_transfer = user.by_transfer;
        this.name = user.name;
        this.use_certificate = user.use_certificate;
        this.protocol = user.protocol;
        this.original_email = user.email;
        this.email = user.email;
        this.uf_id = user.uf_id;
        this.phone = user.phone;
        this.cep = user.cep;
        this.city = user.city;
        this.address = user.address;
        this.number_address = user.number_address;
        this.cpf = user.cpf;
        this.status_type_id = user.status_type_id;
        this.user_group_id = user.user_group_id;
        this.user_profile_id = user.user_profile_id;
        this.district = user.district;
        this.doctor = user.doctor;
        this.technical_responsible = user.technical_responsible;
        this.user_technical_responsible = user.technical_responsible;
        this.created_at = user.created_at;
        this.updated_at = user.updated_at;
        this.photo_url = user.photo_url;
        this.allow_home_care = user.allow_home_care;
        this.office = user.office;
        this.nickname = user.nickname;
        this.date_of_birth = user.date_of_birth
          ? moment(user.date_of_birth).format("YYYY-MM-DD")
          : "";
        this.gender_id = user.gender_id;
        this.nationality = user.nationality;
        this.city_of_birth = user.city_of_birth;
        this.identity_number = user.identity_number;
        this.complement = user.complement;
        this.complement_uf_id = user.complement_uf_id;
        this.complement_agency = user.complement_agency;
        this.complement_issue_date = user.complement_issue_date
          ? moment(user.complement_issue_date).format("YYYY-MM-DD")
          : "";
        this.national_health_card_number = user.national_health_card_number;
        this.code_and_description = user.code_and_description;
        this.city_of_birth_uf_id = user.city_of_birth_uf_id;
        this.naturalization_date = user.naturalization_date
          ? moment(user.naturalization_date).format("YYYY-MM-DD")
          : "";
        this.country_of_birth = user.country_of_birth;
        this.passport_number = user.passport_number;
        this.issuing_country = user.issuing_country;
        this.date_of_issue = user.date_of_issue
          ? moment(user.date_of_issue).format("YYYY-MM-DD")
          : "";
        this.expiry_date = user.expiry_date
          ? moment(user.expiry_date).format("YYYY-MM-DD")
          : "";
        this.geolocation = user.geolocation;

        for (let pcc of this.professional_class_councils) {
          if (pcc.id == user.professional_class_council_id) {
            this.professional_class_council = pcc;
          }
        }

        this.professional_class_councils_id =
          user.professional_class_council_id;

        if (this.professional_class_council.name == "COREN") {
          let coren = onlyCodeCoren(user.professional_class_council_value);
          if (coren) {
            this.coren_uf = coren.uf;
            this.coren_code = coren.code;
            this.coren_category = coren.category;
          }
        } else if (this.professional_class_council.id) {
          let council_value = String(user.professional_class_council_value);
          this.formatCouncilValue(council_value);
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getUserBryCertificateByUserId() {
      try {
        const { id } = this;

        const response = await api.post("/bry/user/certificate", {
          id,
        });

        const { user_bry_certificate } = response.data;

        this.user_bry_certificate = user_bry_certificate;
      } catch (error) {
        console.log(error);
      }
    },
    formatCouncilValue(council_value) {
      try {
        for (let item of this.professional_class_councils) {
          council_value = String(council_value).replace(`${item.name}-`, "");
        }

        let council = council_value.split(" ");

        let uf = council[0];
        let number = council[1];

        this.crm_value = number;
        this.crm_uf = uf;
      } catch (error) {
        console.log(error);
      }
    },
    async getStatusUsers() {
      try {
        const params = { type: "USUARIO" };
        const response = await api.get("/rest-home/type/status/all", {
          params,
        });
        const { error, errors, status } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.statusTypes = status;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getUserGroups() {
      try {
        const response = await api.get("/rest-home/groups");

        const { error, errors, groups } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.userGroups = groups;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getUserProfiles() {
      try {
        const response = await api.get("/rest-home/profiles");

        const { error, errors, profiles } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.userProfiles = profiles;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getGenders() {
      try {
        const response = await api.get("/genders");

        const { error, errors, genders } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.genders = genders;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async update() {
      try {
        this.loading = true;
        this.typeAction = "UPDATE";

        const params = {
          id: this.id,
          status_type_id: this.status_type_id,
          user_group_id: this.user_group_id,
          user_profile_id: this.user_profile_id,
          name: this.name,
          cpf: this.cpf,
          email: this.email,
          uf_id: this.uf_id,
          phone: this.phone,
          cep: this.cep,
          city: this.city,
          address: this.address,
          number_address: this.number_address,
          district: this.district,
          nickname: this.nickname,
          date_of_birth: this.date_of_birth,
          gender_id: this.gender_id,
          nationality: this.nationality,
          city_of_birth: this.city_of_birth,
          identity_number: this.identity_number,
          complement: this.complement,
          complement_uf_id: this.complement_uf_id,
          complement_agency: this.complement_agency,
          complement_issue_date: this.complement_issue_date,
          national_health_card_number: this.national_health_card_number,
          code_and_description: this.code_and_description,
          city_of_birth_uf_id: this.city_of_birth_uf_id,
          naturalization_date: this.naturalization_date,
          country_of_birth: this.country_of_birth,
          passport_number: this.passport_number,
          issuing_country: this.issuing_country,
          date_of_issue: this.date_of_issue,
          expiry_date: this.expiry_date,
          password: this.password,
        };
        const response = await api.patch("/rest-home/user", params);
        const { error, errors, message, password } = response.data;

        if (!error) {
          this.get();
          this.$bvModal.hide("password");
          toast(message, "success");
          this.action_update = false;
          this.time_action_update = 30;
          this.hanldeIntervalToUpdate();
          this.password = "";
          this.errors = [];
        } else {
          if (password) {
            if (
              errors.filter(
                ({ message }) => String(message).indexOf("Informe a senha") > -1
              ).length == 0
            ) {
              this.errorsPassword = errors;
            } else {
              this.errorsPassword = [];
            }
            this.$bvModal.show("password");
          } else {
            this.errorsPassword = [];
            this.$bvModal.hide("password");
            this.errors = errors;
          }
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async updateProfession() {
      try {
        this.loading = true;
        this.typeAction = "PROFESSION";

        let professional_class_council_value;
        if (this.professional_class_council.name == "COREN") {
          professional_class_council_value = `COREN-${this.coren_uf}-${this.coren_code}-${this.coren_category}`;
        } else if (this.professional_class_council.id) {
          professional_class_council_value = `${this.professional_class_council.name}-${this.crm_uf} ${this.crm_value}`;
        }

        const params = {
          id: this.id,
          professional_class_council_id: this.professional_class_council.id,
          professional_class_council_value,
          office: this.office,
          password: this.password,
        };

        const response = await api.patch("/rest-home/user/profession", params);
        const { error, errors, message, password } = response.data;

        if (!error) {
          this.get();
          this.$bvModal.hide("password");
          toast(message, "success");
          this.action_update = false;
          this.time_action_update = 30;
          this.hanldeIntervalToUpdate();
          this.password = "";
          this.errors = [];
        } else {
          if (password) {
            if (
              errors.filter(
                ({ message }) => String(message).indexOf("Informe a senha") > -1
              ).length == 0
            ) {
              this.errorsPassword = errors;
            } else {
              this.errorsPassword = [];
            }
            this.$bvModal.show("password");
          } else {
            this.errorsPassword = [];
            this.$bvModal.hide("password");
            this.errors = errors;
          }
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async updateProfessionCheckbox() {
      try {
        this.loading = true;
        this.typeAction = "PROFESSION_CHECKBOX";

        const params = {
          id: this.id,
          doctor: this.doctor,
          technical_responsible: permission("read", "technical_responsible")
            ? this.this.technical_responsible
            : 0,
          password: this.password,
        };

        const response = await api.patch(
          "/rest-home/user/profession-checkbox",
          params
        );
        const { error, errors, message, password } = response.data;

        if (!error) {
          this.get();
          this.$bvModal.hide("password");
          toast(message, "success");
          this.action_update = false;
          this.time_action_update = 30;
          this.hanldeIntervalToUpdate();
          this.password = "";
          this.errors = [];
        } else {
          if (password) {
            if (
              errors.filter(
                ({ message }) => String(message).indexOf("Informe a senha") > -1
              ).length == 0
            ) {
              this.errorsPassword = errors;
            } else {
              this.errorsPassword = [];
            }
            this.$bvModal.show("password");
          } else {
            this.errorsPassword = [];
            this.$bvModal.hide("password");
            this.errors = errors;
          }
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async updateProfilePic(image) {
      try {
        if (!image) {
          return;
        }

        this.loadingImage = true;

        let photo = image;
        if (photo.size > 10 * 1024 * 1024) {
          this.new_profile_pic_errors.push({
            id: this.new_profile_pic_errors.length,
            message: "A imagem deve ter até 10MB",
          });
          this.new_profile_pic = null;
          return;
        }

        let params = {
          user_id: this.id,
        };
        let formData = new FormData();
        formData.append("photo", photo, photo.name);
        let response = await api.put("/rest-home/user/picture", formData, {
          params,
        });
        let { error, errors, message } = response.data;

        if (error) {
          this.new_profile_pic = errors;
        } else {
          this.new_profile_pic = null;
          this.new_profile_pic_errors = [];
          this.get();
          toast(message, "success");
        }

        this.loadingImage = false;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteProfilePic() {
      try {
        this.loadingImage = true;

        let params = { user_id: this.id };
        const response = await api.delete("/rest-home/user/picture", {
          params,
        });
        const { error, message, errors } = response.data;

        if (error) {
          this.new_profile_pic_errors = errors;
        } else {
          this.new_profile_pic_errors = [];
          this.get();
          toast(message, "success");
        }

        this.loadingImage = false;
      } catch (error) {
        console.log(error);
      }
    },
    async formatPhone() {
      let filter = this.phone.replace(/[^0-9]/g, "");
      if (filter.length <= 10) {
        this.phone = filter.replace(
          /^([0-9]{2})([0-9]{4})([0-9]{4})$/,
          "($1) $2-$3"
        );
      } else if (filter.length == 11) {
        this.phone = filter.replace(
          /^([0-9]{2})([0-9]{1})([0-9]{4})([0-9]{4})$/,
          "($1) $2.$3-$4"
        );
      } else {
        this.phone = filter.replace(/^([0-9]{2})([0-9]*)$/, "($1) $2");
      }
    },
    async formatCoren() {
      this.coren = this.coren_code.toUpperCase();

      let filter = this.coren_code.replace(/[^A-Z0-9]/, "");
      if (filter.match(/^([A-Z]{2})([0-9]{5,7})([A-Z]{2,4})$/)) {
        this.coren_code = filter.replace(
          /^([A-Z]{2})([0-9]{3})([0-9]{2,4})([A-Z]{2,4})$/,
          "COREN-$1-$2.$3-$4"
        );
      } else if (filter.match(/^(COREN)([A-Z]{2})([0-9]{5,7})([A-Z]{2,4})$/)) {
        this.coren_code = filter.replace(
          /^(COREN)([A-Z]{2})([0-9]{3})([0-9]{2,4})([A-Z]{2,4})$/,
          "$1-$2-$3.$4-$5"
        );
      }
    },
    handleToBack: () => routes.go(-1),
    handleToPermissions() {
      routes.push({
        name: "permissions",
        params: {
          profile_id: this.user_profile_id,
          profile_name: this.name,
        },
      });
    },

    print() {
      let { id } = this;

      let route = this.$router.resolve({
        name: "user_print",
        params: {
          id,
        },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>

<style scoped>
.user-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.user-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Section */
.user-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.header-content {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 16px;
}

/* Warning Section */
.warning-section {
  margin-bottom: 24px;
}

/* Modern Tabs */
.tabs-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;
  overflow: hidden;
}

.modern-tabs {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #e5e7eb;
}

.tab-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 16px 12px;
  background: transparent;
  border: none;
  color: #6b7280;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  min-width: 100px;
  flex: 1;
}

.tab-btn:hover {
  background: #f8fafc;
  color: #0f65b0;
}

.tab-btn.active {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  color: #0f65b0;
  border-bottom-color: #0f65b0;
}

.tab-btn i {
  font-size: 16px;
}

.tab-btn span {
  font-size: 11px;
  font-weight: 600;
}

/* Tab Content */
.tab-content-modern {
  margin-bottom: 32px;
}

.tab-panel {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Form Cards */
.form-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  margin-bottom: 24px;
}

.card-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.card-title i {
  color: #0f65b0;
}

.card-content {
  padding: 24px;
}

/* Form Grid */
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group.span-2 {
  grid-column: span 2;
}

.form-group.span-full {
  grid-column: 1 / -1;
}

.form-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
}

.form-control-modern {
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #1e293b;
  background: white;
  transition: all 0.3s ease;
}

.form-control-modern:focus {
  outline: none;
  border-color: #0f65b0;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
}

.form-control-modern::placeholder {
  color: #9ca3af;
}

.form-help {
  font-size: 11px;
  color: #6b7280;
  margin-top: 4px;
}

/* Input Groups */
.input-group-modern {
  display: flex;
  gap: 8px;
}

.input-group-modern .form-control-modern {
  flex: 1;
}

.btn-add-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 12px 16px !important;
  font-weight: 600 !important;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-add-modern:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4) !important;
}

/* Checkbox Modern */
.checkbox-modern {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 2px solid #e5e7eb;
  transition: all 0.3s ease;
}

.checkbox-modern:hover {
  border-color: #cbd5e1;
}

.checkbox-input {
  width: 20px;
  height: 20px;
  accent-color: #0f65b0;
}

.checkbox-label {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
  margin: 0;
  cursor: pointer;
}

/* Special Sections */
.coren-section,
.council-section {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e5e7eb;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
}

.section-title i {
  color: #0f65b0;
}

/* Photo Section */
.photo-section {
  text-align: center;
}

.photo-preview {
  margin-bottom: 24px;
}

.profile-image-large {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #0f65b0;
  box-shadow: 0 8px 32px rgba(15, 101, 176, 0.2);
}

.photo-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 20px;
}

.btn-upload-photo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3);
  position: relative;
  overflow: hidden;
}

.btn-upload-photo:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(15, 101, 176, 0.4);
}

.file-input-hidden {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.btn-remove-photo {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  font-weight: 600 !important;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3) !important;
}

.btn-remove-photo:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4) !important;
}

.photo-info {
  border-top: 1px solid #e5e7eb;
  padding-top: 16px;
}

.info-text {
  color: #6b7280;
  font-size: 12px;
  margin: 4px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Card Actions */
.card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
  margin-top: 20px;
}

/* Footer */
.form-footer {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 24px;
  margin-bottom: 32px;
}

.footer-info {
  margin-bottom: 20px;
}

.creation-info {
  display: flex;
  gap: 24px;
  margin-top: 16px;
}

.info-item {
  color: #6b7280;
  font-size: 14px;
  margin: 0;
  display: flex;
  align-items: center;
}

.info-item i {
  color: #9ca3af;
  margin-right: 4px;
}

.footer-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.left-actions,
.right-actions {
  display: flex;
  gap: 12px;
}

/* Button Styles */
.btn-primary-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-primary-modern:hover:not(:disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4) !important;
}

.btn-primary-modern:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}

.btn-secondary-modern {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 20px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-secondary-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.4) !important;
}

.btn-save-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-save-modern:hover:not(:disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4) !important;
}

.btn-save-modern:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}

/* Loading Overlays */
.loading-overlay,
.photo-overlay {
  border-radius: 16px;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .form-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }

  .form-group.span-2 {
    grid-column: span 1;
  }
}

@media (max-width: 768px) {
  .user-container {
    padding: 0 16px;
  }

  .header-content {
    grid-template-columns: 1fr;
    gap: 16px;
    text-align: center;
  }

  .page-title {
    font-size: 24px;
    justify-content: center;
  }

  .modern-tabs {
    flex-direction: column;
  }

  .tab-btn {
    flex-direction: row;
    justify-content: center;
    min-width: auto;
    padding: 12px 16px;
  }

  .tab-btn span {
    font-size: 12px;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .form-group.span-2,
  .form-group.span-full {
    grid-column: span 1;
  }

  .footer-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .left-actions,
  .right-actions {
    justify-content: center;
  }

  .creation-info {
    flex-direction: column;
    gap: 8px;
  }

  .photo-actions {
    flex-direction: column;
    align-items: center;
  }

  .profile-image-large {
    width: 150px;
    height: 150px;
  }
}

@media (max-width: 480px) {
  .card-content {
    padding: 16px;
  }

  .card-header {
    padding: 16px;
  }

  .card-title {
    font-size: 16px;
  }

  .tab-btn {
    padding: 10px 12px;
  }

  .tab-btn i {
    font-size: 14px;
  }

  .tab-btn span {
    font-size: 10px;
  }
}
</style>